import { render, staticRenderFns } from "./bfhs-block.vue?vue&type=template&id=1605d418&"
import script from "./bfhs-block.vue?vue&type=script&lang=js&"
export * from "./bfhs-block.vue?vue&type=script&lang=js&"
import style0 from "./bfhs-block.vue?vue&type=style&index=0&id=1605d418&prod&lang=scss&module=true&"
import style1 from "./bfhs-block.vue?vue&type=style&index=1&id=1605d418&prod&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports